import { all, call } from 'redux-saga/effects';

import watchTicketsSaga from './tickets';

export function* virtualsSaga() {
  yield all([call(watchTicketsSaga)]);
}
